module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Man of the Match Awards")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 players the have won the most Man of the Match\n      awards across all seasons of IPL.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Man of the Match Awards is given after each match to the best performer.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chris Gayle leads the list, being awarded the MOTM 17 times in IPL.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Yusuf pathan and AB de Villiers follow with 16 and 15 MOTM awards\n        respectively.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Sadly, no bowlers make it to the top 10 list.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31bb9858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AwardsMOTM.vue
// module id = 396
// module chunks = 1